var s, interval;
s = 3;

function initAlert() {
    var content, div, css, styleElement;

    //Crear css en HTML
    css = document.createElement('style');
    css.type = 'text/css';
    styleElement = `.container__snackbar{position: relative;left:-50%;min-height:70px;min-width:550px;max-width:550px;display:flex;align-items:center;justify-content:space-evenly;margin:auto;border-radius:8px;opacity:0;visibility:hidden;z-index:9999999; cursor: pointer;}.container__snackbar.active{opacity:1;transition:.9s opacity;animation:slide-bottom .9s cubic-bezier(0.250,0.460,0.450,0.940) both;visibility:visible}.container__snackbar figure{width:40px;height:40px;margin:0}.container__snackbar strong{font-style:normal;font-weight:bold;font-size:16px;line-height:21px;text-transform:capitalize}.container__snackbar .content__message{min-width:340px;max-width:340px;overflow:hidden;text-align:left;padding:20px 0;cursor:pointer;}.container__snackbar .content__message label{font-style:normal;font-weight:normal;font-size:16px;line-height:21px;cursor:pointer;}.container__snackbar button{display: flex;align-items: center;width:35px;height:35px;background:transparent;outline:0;border:0;cursor:pointer;border-radius:50%;transition:1s cubic-bezier(0.075,0.82,0.165,1)}.container__snackbar button:hover{background-color:rgba(0,0,0,0.09)}.container__snackbar.error{color:#fff;background:#a62727;box-shadow: 0 4px 10px 0 rgba(198, 65, 101, 0.5);}.container__snackbar.error button .close{fill:#fff}.container__snackbar.success{background:#acf1cc;color:#034927;box-shadow: 0 4px 10px 0 rgb(25 90 67 / 50%);}.container__snackbar.success button .close{fill:#01603e}.container__snackbar.warning{background:#dee79c;color:#616639;box-shadow: 0 4px 10px 0 #aab273;}.container__snackbar.warning button .close{fill:#616639}@-webkit-keyframes slide-bottom{0%{-webkit-transform:translateY(0);transform:translateY(0)}100%{-webkit-transform:translateY(30px);transform:translateY(30px)}}@keyframes slide-bottom{0%{-webkit-transform:translateY(0);transform:translateY(0)}100%{-webkit-transform:translateY(30px);transform:translateY(30px)}}@-webkit-keyframes slide-off{0%{opacity:1;-webkit-transform:translateY(30px);transform:translateY(30px)}100%{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slide-off{0%{opacity:1;-webkit-transform:translateY(30px);transform:translateY(30px)}100%{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}}@media (min-width:300px) and (max-width:540px){.container__snackbar{position:relative;left:-50%;min-height:70px;min-width:300px;max-width:550px;display:flex;align-items:center;justify-content:space-evenly;margin:auto;border-radius:8px;opacity:0;visibility:hidden;z-index:9999999}.container__snackbar figure{width:40px;height:20px;margin:0;padding:0 5px;text-align:center}.container__snackbar button svg,.container__snackbar figure svg{width:20px;height:20px}.container__snackbar strong{font-style:normal;font-weight:700;font-size:13px;line-height:0;text-transform:capitalize;padding:0 5px}.container__snackbar .content__message{min-width:auto;max-width:340px;overflow:hidden;text-align:left;padding:20px 0}.container__snackbar .content__message label{font-style:normal;font-weight:400;font-size:12.5px;line-height:0}}`;
    if (css.styleSheet) {
        css.styleSheet.cssText = styles;
    } else {
        css.appendChild(document.createTextNode(styleElement));
        document.getElementsByTagName("head")[0].append(css);
    }
    //End
    //Crear div en HTML
    content = "<div class=\"container__snackbar\"><figure id=\"img\"></figure><strong id=\"title\">!error</strong><div class=\"content__message\"><label id=\"message\">lorem2</label></div><button id=\"btn\"><svg class=\"close\" focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"></path></svg></button></div>";
    div = document.createElement('div');
    div.style = "position: fixed; left: 50%; z-index: 999999; top: 0;";
    div.innerHTML = content;
    document.body.append(div);
    //End

    //Eventos Mouse sobre snackbar!!
    handlerEvents();
}

function showAlert(message, type) {
    return new Promise((resolve, reject) => {
        var title, icon;

        if (typeof type !== 'string') {
            reject({ success: false, message: 'El tipo de alerta debe ser un string', dismiss: false });
            throw new Error('El tipo de alerta debe ser un string');
        }

        switch (type.toLowerCase()) {
            case 'error':
                title = 'Error!';
                icon = '<svg class=\"error\" focusable=\"false\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" aria-hidden=\"true\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM13.606 15.7273L17.8787 20L13.606 24.2727L15.7273 26.394L20 22.1213L24.2727 26.394L26.394 24.2727L22.1213 20L26.394 15.7273L24.2727 13.606L20 17.8787L15.7273 13.606L13.606 15.7273Z\" fill=\"white\"/></svg>';
                break;
            case 'success':
                title = 'Éxito!';
                icon = '<svg class=\"succcess\" focusable=\"false\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" aria-hidden=\"true\"><circle xmlns="http://www.w3.org/2000/svg" cx="20" cy="20" r="20" fill="#35AD6C"/><path xmlns="http://www.w3.org/2000/svg" d="M14.4993 18.7789L12.167 21.3885L17.7151 26.3471L27.8326 17.3049L25.5003 14.6952L17.7151 21.653L14.4993 18.7789Z" fill="white"/></svg>';
                break;
            case 'warning':
                title = 'Advertencia!';
                icon = '<svg class=\"warning\" focusable=\"false\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" aria-hidden=\"true\"><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M39 35L20.5 3L2 35H39ZM18.8182 29.9474V26.5789H22.1818V29.9474H18.8182ZM18.8182 23.2105H22.1818V16.4737H18.8182V23.2105Z" fill="#A2B605"/></svg>';
                break;

            default:
                reject({ success: false, message: `El tipo de alert:${type} es desconocido, por favor ingrese las opciones establecidas: warning, success o error `, dismiss: false });
                throw new Error(`El tipo de alert:${type} es desconocido, por favor ingrese las opciones establecidas: warning, success o error `);
        }

        if (typeof message !== 'string') {
            reject({ success: false, message: 'El tipo de alerta debe ser un string', dismiss: false });
            throw new Error('El mensaje debe ser un string');
        }
        var div = document.querySelector('.container__snackbar');

        if (div === null) {
            initAlert();
            div = document.querySelector('.container__snackbar');
        }

        if (!div.classList.contains('active')) {
            //Se cambia Titulo de alert!
            document.querySelector('#title').textContent = title;
            //Se cambia Mensaje de alerta!
            document.querySelector('#message').textContent = message;
            //Se cambia Icono de alerta!
            document.querySelector('#img').innerHTML = icon;
            //Se cambia estado de alerta!
            div.classList.add(type, 'active');

            //Si no se hace cierra la alert de manera manual, se cerrar auto. a los 4 seg
            interval = setInterval(eventInterval, 1000);

            //Manejo de evento click!
            document.querySelector('#btn').addEventListener('click', () => {
                div.style.animation = 'slide-off .9s both';

                setTimeout(() => {
                    closeAlert();
                    s = 4;
                    clearInterval(interval)
                }, 1000);

            })

        } else {
            setTimeout(() => {
                return showAlert(type, message);
            }, 100);
        }
    })
}

function closeAlert() {
    return new Promise((resolve, reject) => {
        var div = document.querySelector('.container__snackbar');
        if (!div) {
            reject({ success: false, message: 'No se encuentra ningun Alert desplegado', dismiss: false });
            throw new Error('No se encuentra ningun Alert desplegado');
        } else {
            const parent = div.parentElement;
            let c = [...div.classList];
            c = c.slice(1, c.length);
            for (let i = 0; i < c.length; i++) {
                div.classList.remove(c[i]);
            }
            div.style.animation = null;
            parent.remove();

            resolve({ success: true, message: null, dismiss: true })
        }
    })
}

//Maneja eventos de Mouse Over y Mouse Leave para para mantener el temporizado del mensaje expuesto
//Ademas permite copiar mensaje al hacer click en snackbar!!
function handlerEvents() {
    var div = document.querySelector('.container__snackbar');
    div.addEventListener('mouseover', function() {
        clearInterval(interval);
    })

    div.addEventListener('mouseleave', function() {
        interval = setInterval(eventInterval, 1000);
    })

    div.addEventListener('click', function() {
        var m, input;
        m = document.querySelector('#message').textContent;
        input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.value = m;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input)
    })
}

function eventInterval() {
    const div = document.querySelector('.container__snackbar');
    if (div === null || div === undefined) return;
    if (div.classList.contains('active')) {
        if (s === 0) {
            div.style.animation = 'slide-off .9s both';
            setTimeout(() => {
                closeAlert()
            }, 1000);

            s = 4;
            clearInterval(interval);
        } else s--;
    }
}

//Create by Jose-arc